import config from 'emun.on-demand/templates/_config' 
import labels from 'emun.on-demand/templates/_labels'
import resolve from 'ioc/resolve'
import basicController from 'servicestack/basic.controller.properties'
import ProductTemplate from 'emun.on-demand/lib/product-template'
import AutoQuery from 'servicestack/auto-query/auto-query'
import modals from 'webmodals/modals'

class ProductTemplateManagerController {
    constructor($state, $stateParams) {
        basicController(this)
        const $ctrl = this;
        let criteria = Object.assign({active:true}, $stateParams);
        Object.assign($ctrl, {$state}, $stateParams, config, labels);
        $ctrl.navs = $state.getNav('od-product-templates');
        $ctrl.panelType = 'default';

        let options = Object.assign({
            url: 'QueryProductTemplates.json',
            tagTotalsUrl: 'QueryProductTemplateTagTotals.json?',
            orderBy: '-CreatedOn,Id',
            autoLoad: true,
            append: false,
            navs: [],
            pageSize: config.pageSize,
            filters: config.filters,
            sortOptions: config.sortOptions,
            criteria,
            scrub(response) {
                response.data.results = response.data.results.map(r => new ProductTemplate(r));
            }
        }, config);

        $ctrl.query = new AutoQuery(options);
        $ctrl.bus = $ctrl.query.bus;
    }

    addProductTemplate() {
        const $ctrl = this;
        let productTemplate = {
            id:0,
            areas:[]
        };
        return $ctrl.editProductInfo(productTemplate);
    }

    cloneProductTemplate(productTemplate) {
        const $ctrl = this;
        if(!$ctrl.$session.isCorpOrAbove()) return 'unauthorized';
        const url = 'CreateProductTemplate.json';
        let req = Object.assign({}, productTemplate);
        delete req.id;
        delete req.euid;
        req.sku += '-Clone';
        return $ctrl.bus.send(url, req).then(res => {      
            return $ctrl.$state.transitionTo('od-product-templates.editor', {productTemplateId:res.data.id});
        });
    }

    editProductInfo(productTemplate) {
        const $ctrl = this;
        if(!$ctrl.$session.isCorpOrAbove()) return 'unauthorized';
        $ctrl.productTemplate = productTemplate;
        //return $ctrl.$state.transitionTo('od-product-templates.editor', {productTemplateId:productTemplate.id});
        return editProductPrompt({
            subTitle: productTemplate.sku,
            productTemplate
        }).then(result => {
            Object.assign(productTemplate, result); 
            $ctrl.query.load(true);
        });
    }

    filterStatus(active) {
        const $ctrl = this;
        $ctrl.query.criteria.active = active;
        $ctrl.query.load(true);
    }

    statusLabel(active) {
        return active === true ? 'Active' : active === false ? 'Inactive' : 'All'
    }

    toggleProduct(pt, skip, activated) {
        const $ctrl = this;
        if( activated !== true && activated !== false) activated = !pt.active;
        let url = `${pt.active?'Dea':'A'}ctivateProductTemplate/${pt.id}.json`;
        pt.active = activated;
        pt.status = activated ? 'Active' : 'Inactive';

        $ctrl.bus.send(url).then(res => Object.assign(pt, res.data)); //$ctrl.query.load(true)
    }

    toggleProducts(activated) {
        let $ctrl = this;
        $ctrl.query.results.forEach(p => $ctrl.toggleProduct(p, true, activated));
    }

    addTags() {
        return modals.alert('This feature has not been implemented as of yet.', 'Under Construction');
    }

    $onDestroy() {
        this.query.dispose();
    }
}

export default ProductTemplateManagerController;
